import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Header } from 'components/Text';
import { GJENSIDIGE_LINKS_REGISTER, GJENSIDIGE_LINKS_TRANSFER, REDGO_LINK } from 'constants/urls';
import gjensidigeAd from './images/gjensidige_ad.jpg';
import redgoAd from './images/redgo_ad.jpg';
import SummaryPageAd from './SummaryPageAd';
export let SummaryPageAdType;
(function (SummaryPageAdType) {
  SummaryPageAdType["TRANSFER"] = "transfer";
  SummaryPageAdType["REGISTER"] = "register";
})(SummaryPageAdType || (SummaryPageAdType = {}));
function getGjensidigeLinks(type) {
  switch (type) {
    case SummaryPageAdType.TRANSFER:
      return GJENSIDIGE_LINKS_TRANSFER;
    case SummaryPageAdType.REGISTER:
      return GJENSIDIGE_LINKS_REGISTER;
    default:
      throw new Error('Invalid SummaryPageAdType');
  }
}
export default function SummaryPageAds({
  type,
  lpn
}) {
  const {
    t
  } = useTranslation();
  const {
    readMore,
    combinedOffer,
    checkPrice
  } = getGjensidigeLinks(type);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, null, t('summary_page_ads.header')), /*#__PURE__*/React.createElement(SummaryPageAd, {
    title: t('summary_page_ads.gjensidige_ad.title'),
    text: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "summary_page_ads.gjensidige_ad.text",
      components: {
        a: /*#__PURE__*/React.createElement("a", {
          href: readMore,
          target: "_blank"
        })
      }
    }),
    image: gjensidigeAd,
    primaryButton: {
      text: t('summary_page_ads.gjensidige_ad.primary_button'),
      link: checkPrice(lpn)
    },
    secondaryButton: {
      text: t('summary_page_ads.gjensidige_ad.secondary_button'),
      link: combinedOffer
    }
  }), /*#__PURE__*/React.createElement(SummaryPageAd, {
    title: t('summary_page_ads.redgo_ad.title'),
    text: t('summary_page_ads.redgo_ad.text'),
    image: redgoAd,
    primaryButton: {
      text: t('summary_page_ads.redgo_ad.primary_button'),
      link: REDGO_LINK
    }
  }));
}